import { render, staticRenderFns } from "./OrganisationView.vue?vue&type=template&id=30aa3863&scoped=true"
import script from "./OrganisationView.vue?vue&type=script&lang=js"
export * from "./OrganisationView.vue?vue&type=script&lang=js"
import style0 from "./OrganisationView.vue?vue&type=style&index=0&id=30aa3863&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aa3863",
  null
  
)

export default component.exports